(function () {
  'use strict';
  if (window.__bapeSourceCartSync) return;
  window.__bapeSourceCartSync = true;

  var pending = null;
  var timers = [];
  var cartMutation = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[/?#]|$)/i;

  function render(count) {
    count = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-bape-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
    document.querySelectorAll('.sw-header__utilities a[href="/cart"], .sw-header__utilities a[href$="/cart"]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function refresh() {
    if (pending) return pending;
    pending = window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
      .then(function (cart) { render(cart.item_count); return cart.item_count; })
      .catch(function () { return null; })
      .finally(function () { pending = null; });
    return pending;
  }

  function schedule() {
    timers.forEach(window.clearTimeout);
    timers = [0, 180, 550, 1200].map(function (delay) { return window.setTimeout(refresh, delay); });
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    return input && typeof input.url === 'string' ? input.url : '';
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var url = urlOf(args[0]);
    return nativeFetch.apply(window, args).then(function (response) {
      if (response.ok && cartMutation.test(url)) schedule();
      return response;
    });
  };

  if (window.XMLHttpRequest) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__bapeCartMutation = cartMutation.test(String(url || ''));
      return nativeOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      if (this.__bapeCartMutation) this.addEventListener('loadend', function () { if (this.status >= 200 && this.status < 400) schedule(); }, { once: true });
      return nativeSend.apply(this, arguments);
    };
  }

  ['cart:update', 'cart:change', 'cart:refresh', 'cartUpdate', 'product:added', 'ajaxProduct:added', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, schedule);
    window.addEventListener(name, schedule);
  });
  document.addEventListener('DOMContentLoaded', refresh, { once: true });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  if (document.readyState !== 'loading') refresh();
})();
